import React, { useState, useRef } from "react";
import VehicleContext from "./VehicleContext";
import ServiceOrderStatus from "../shared/Enums/ServiceOrderStatus";
import apiManager from "../api/apiManager";
import API_ENDPOINTS from "../api/apiEndpoints";
import {
  showLoader,
  hideLoader,
} from "../shared/Services/Loader/loaderService";
import { showErrorMessage } from "../shared/Services/toasterService";
import { useSelectedDealership } from "../hooks/useLocalStorage";

const VehicleProvider = ({ children }) => {
  const [status, setStatus] = useState(ServiceOrderStatus.NEW);
  const [selectedServices, setSelectedServices] = useState([]);
  const [repairOrder, setRepairOrder] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [vehicle, setVehicle] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [vehicleId, setVehicleId] = useState(null);
  const [isViewMode, setIsViewMode] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [dealershipId, setDealershipId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showTable, setShowTable] = useState(false);

  const stepperRef = useRef(null);
  const stepper = useRef(null);

  const [selectedDealershipId] = useSelectedDealership();

  const handleSearch = async (dealershipId) => {
    showLoader();
    try {
      const payload = {
        dealershipId: selectedDealershipId || dealershipId,
        searchText: searchText,
      };
      const response = await apiManager.post(
        API_ENDPOINTS.CUSTOMER_GET_VEHICLE,
        payload
      );
      if (response.status == 200) {
        const result = response.data;
        setSearchResults(result);
        setShowTable(true);
      } else {
        showErrorMessage("Failed to fetch search results");
      }
    } catch (error) {
      showErrorMessage(error);
    } finally {
      hideLoader();
    }
  };

  const onSelectCustomer = async (item) => {
    showLoader();
    try {
      const customerRes = await apiManager.post(
        API_ENDPOINTS.CUSTOMER_GET_BY_ID,
        { id: item.customerId }
      );
      const customer = customerRes.data;
      const vehicleRes = await apiManager.post(
        API_ENDPOINTS.CUSTOMER_GET_VEHICLE_BY_ID,
        { id: item.vehicleId }
      );
      const vehicle = vehicleRes.data;
      setCustomer(customer);
      setVehicle(vehicle);
      setCustomerId(item.customerId);
      setVehicleId(item.vehicleId);
      setShowTable(false);
      if (stepper && stepper.current) stepper.current.to(2);
    } catch (err) {
      showErrorMessage(err);
    } finally {
      hideLoader();
    }
  };

  const value = {
    status,
    setStatus,
    selectedServices,
    setSelectedServices,
    repairOrder,
    setRepairOrder,
    customer,
    setCustomer,
    vehicle,
    setVehicle,
    customerId,
    setCustomerId,
    vehicleId,
    setVehicleId,
    isViewMode,
    setIsViewMode,
    isEditMode,
    setIsEditMode,
    dealershipId,
    setDealershipId,
    stepperRef,
    stepper,
    handleSearch,
    onSelectCustomer,
    showModal,
    setShowModal,
    searchText,
    setSearchText,
    searchResults,
    setSearchResults,
    showTable,
    setShowTable,
  };

  return (
    <VehicleContext.Provider value={value}>{children}</VehicleContext.Provider>
  );
};

export default VehicleProvider;
